import { createStore, Store } from 'redux';
import { reducer } from './list.reducer';
import { IAction } from './list.action';
import { StoreObject } from './storeObject';

export class ValueStore {

	public store: Store<StoreObject>;

	constructor(values) {
		this.store = createStore(reducer, values);
	}

	get values() {
		return this.store.getState();
	}

	replaceReducer(storeObject: StoreObject) {
		this.store.replaceReducer(() => storeObject);
	}

	dispatch(action: IAction) {
		this.store.dispatch(action);
	}
}
